// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../imports.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  max-width: none;
  max-width: initial;
}

.container.container-dct {
  max-width: 1076px;
}

.container.container-dct-small {
  max-width: 804px;
}

footer {
  z-index: 1;
}

.modal-dialog {
  border-radius: 0.25rem;
}

/* Accessiblity fixes */

.focus,
:focus,
button:focus {
  outline: revert;
}

.radio[data-am-inputselection] input[type="radio"] {
  visibility: visible;
}

.radio[data-am-inputselection] input[type="radio"]:focus + label {
  font-weight: 500;
}

[data-am-accordion] input[type="checkbox"] {
  visibility: visible;
  opacity: 0;
}

[data-am-accordion] input[type="checkbox"]:focus + label,
[data-am-accordion] label:focus,
[data-am-accordion] label:active {
  outline: 2px solid black;
  outline-offset: -2px;
}

/* End accessibility fixes */

@media (max-width: 599px) {
  .outer-wrapper {
    min-height: 100vh;
    min-height: calc(100vh);
    min-height: calc(var(--vh, 100vh));
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: 100%;
  }
  .outer-inner-wrapper {
    display: grid;
    grid-template-rows: 1fr auto;
    grid-template-columns: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DigitalCompletionTool/DigitalCompletionTool.css"],"names":[],"mappings":"AAEA;EACE,eAAgB;EAAhB,kBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA,uBAAuB;;AAEvB;;;EAGE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;;EAGE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,4BAA4B;;AAE5B;EACE;IACE,iBAAiB;IACjB,uBAAkC;IAAlC,kCAAkC;IAClC,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;EAC7B;AACF","sourcesContent":["@import \"../../imports.css\";\r\n\r\nbody {\r\n  max-width: unset;\r\n}\r\n\r\n.container.container-dct {\r\n  max-width: 1076px;\r\n}\r\n\r\n.container.container-dct-small {\r\n  max-width: 804px;\r\n}\r\n\r\nfooter {\r\n  z-index: 1;\r\n}\r\n\r\n.modal-dialog {\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n/* Accessiblity fixes */\r\n\r\n.focus,\r\n:focus,\r\nbutton:focus {\r\n  outline: revert;\r\n}\r\n\r\n.radio[data-am-inputselection] input[type=\"radio\"] {\r\n  visibility: visible;\r\n}\r\n\r\n.radio[data-am-inputselection] input[type=\"radio\"]:focus + label {\r\n  font-weight: 500;\r\n}\r\n\r\n[data-am-accordion] input[type=\"checkbox\"] {\r\n  visibility: visible;\r\n  opacity: 0;\r\n}\r\n\r\n[data-am-accordion] input[type=\"checkbox\"]:focus + label,\r\n[data-am-accordion] label:focus,\r\n[data-am-accordion] label:active {\r\n  outline: 2px solid black;\r\n  outline-offset: -2px;\r\n}\r\n\r\n/* End accessibility fixes */\r\n\r\n@media (max-width: 599px) {\r\n  .outer-wrapper {\r\n    min-height: 100vh;\r\n    min-height: calc(var(--vh, 100vh));\r\n    display: grid;\r\n    grid-template-rows: auto 1fr;\r\n    grid-template-columns: 100%;\r\n  }\r\n  .outer-inner-wrapper {\r\n    display: grid;\r\n    grid-template-rows: 1fr auto;\r\n    grid-template-columns: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
